import { Injectable } from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {LoadTitles, TitlesActionTypes, TitlesLoaded, TitlesLoadFailed} from "../actions/titles.actions";
import {TitlesService} from "../services/titles.service";
import {Observable, of} from "rxjs";
import {catchError, map, mergeMap} from "rxjs/operators";



@Injectable()
export class LoadTitlesEffects {

  @Effect()
  loadTitles$: Observable<any> = this.actions$.pipe(
    ofType(TitlesActionTypes.LoadTitles),
    mergeMap(action =>
      this.titlesService.getTitles().pipe(
        map(data => new TitlesLoaded(data.titles)),
        catchError((err) => of(new TitlesLoadFailed(err)))
      )
    )
  )

  constructor(private actions$: Actions<LoadTitles>, private titlesService:TitlesService) {}

}
